import { useNavigate } from "react-router-dom";
import { useLead } from "../lib/store";
import { track } from "../lib/track";
import { WhatsAppIcon } from "./icons";

export default function MobileStickyBar() {
  const { openLead } = useLead();
  const navigate = useNavigate();

  return (
    <div
      data-testid="mobile-sticky-action-bar"
      className="glass fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t p-3 md:hidden"
    >
      <button
        onClick={() => {
          track("click_whatsapp", { source: "mobile_sticky_bar" });
          openLead();
        }}
        className="btn btn-wa !py-2.5 text-[13px]"
        data-testid="mobile-sticky-whatsapp-button"
      >
        <WhatsAppIcon className="h-4 w-4" /> WhatsApp
      </button>
      <button
        onClick={() => {
          track("request_quotation", { source: "mobile_sticky_bar" });
          navigate("/custom-trip");
        }}
        className="btn btn-primary !py-2.5 text-[13px]"
        data-testid="mobile-sticky-quotation-button"
      >
        Request Quotation
      </button>
    </div>
  );
}
